import React, { ReactElement } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { initRollbar } from 'utils/rollbar'
import AppContextProvider from 'contexts/AppContext'
import ApolloProvider from 'components/ApolloProvider'
import { store } from './store'
import { Provider } from 'react-redux'
import 'styles/index.scss'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2'
import { plPL } from '@mui/x-date-pickers/locales'
import pl from 'date-fns/locale/pl'
import 'react-checkbox-tree/lib/react-checkbox-tree.css'

// Workaround for Leaflet errors
window.addEventListener('error', e => {
  if (
    e.message === 'this._map is null' ||
    e.message === "Cannot read properties of null (reading 'getBounds')" ||
    e.message === "Cannot read properties of undefined (reading '_leaflet_pos')"
  ) {
    e.preventDefault()
  }
})

initRollbar()

const AppContainer = (): ReactElement => (
  <Provider store={store}>
    <AppContextProvider>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={pl}
        localeText={plPL.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <ApolloProvider>
          <App />
        </ApolloProvider>
      </LocalizationProvider>
    </AppContextProvider>
  </Provider>
)

const container = document.getElementById('root')
if (container) createRoot(container).render(<AppContainer />)
